module.exports = __webpack_public_path__ + "media/images/iconLeft__accent--dark-b197f0f60612168f4b53ef33e5e6dad1.png";